const account = {
  account: {
    plan: {
      title: "契約中プラン",
      button: {
        change: "プラン変更",
      },
      fee_type: {
        number: "データ数課金",
        capacity: "容量課金",
      },
      plan_type: {
        standard: {
          index: "xCausal™ Standard (スタンダード版)",
          func_1: "BIダッシュボード",
          func_2: "因果探索(3種類) ※追加予定",
          func_3: "因果推論(構造的因果モデルベース)",
          func_4: "Smallyticsアルゴリズム",
          func_5: "離散値と連続値の混在利用可",
          func_6: "層別化解析",
          func_7: "直接(NDE)・間接効果(NIE)の推定",
          func_8: "頑健性評価",
        },
        healthcare: {
          index: "xCausal™ for Healthcare (ヘルスケア版)",
          func_1: "BIダッシュボード",
          func_2: "因果探索(3種類) ※追加予定",
          func_3: "因果推論(構造的因果モデルベース)",
          func_4: "Smallyticsアルゴリズム",
          func_5: "離散値と連続値の混在利用可",
          func_6: "層別化解析",
          func_7: "直接(NDE)・間接効果(NIE)の推定",
          func_8: "頑健性評価",
          func_9: "ヘルスケア・ダッシュボード",
          func_10: "論文検索機能",
          func_11: "CKE-LLM(因果知識抽出LLM機能・MSDマニュアル使用可)",
          func_12: "you'dアプリの利用とデータ連携",
        },
      },
    },
    price: {
      title: "",
    },
    payment: {
      title: "支払い方法",
      button: {
        add: "カード追加",
        change: "カード変更",
      },
    },
    danger_zone: {
      title: "注意エリア",
      section: {
        title: "Cancel subscription",
        desc: "Once deleted, it will be gone forever. Please be certain.",
        button: {
          cancel: "Cancel request",
        },
      },
    },
  },

  // ACCOUNT
  "account-title": "アカウント",
  "account-discription":
    "このページでは、組織に関する契約やメンバーなどを管理することができます。",

  // PROFILE
  "account-profile-tab": "プロフィール",

  "account-profile-project-title": "プロジェクト",
  "account-profile-project-field-0": "プロジェクト名",

  "account-profile-title": "プロフィール",
  "account-profile-field-0": "プロジェクト名",
  "account-profile-field-1": "組織名",
  "account-profile-field-2": "メールアドレス",
  "account-profile-field-3": "電話番号",

  "account-profile-owner-title": "オーナー",
  "account-profile-owner-field-1": "部署名",
  "account-profile-owner-field-2": "役職",
  "account-profile-owner-field-3": "名前",

  "account-profile-address-title": "アドレス",
  "account-profile-address-field-1": "住所",
  "account-profile-address-field-2": "市区町村",
  "account-profile-address-field-3": "都道府県",
  "account-profile-address-field-4": "郵便番号",
  "account-profile-address-field-5": "国名",

  "account-profile-logo-title": "プロフィールロゴ",
  "account-profile-logo-note":
    "Note: アップロードされたプロフィールロゴは、利用規約に従って管理・使用されます。",

  "account-profile-field-error-0": "このフィールドは入力が必須です。",
  "account-profile-field-error-1": "このフィールドは入力が必須です。",
  "account-profile-field-error-2": "有効なメールアドレスを入力してください。",
  "account-profile-field-error-3": "有効な電話番号を入力してください。",
  "account-profile-field-error-4": "有効な郵便番号を入力してください。",
  "account-profile-field-error-5": "有効な国コードを入力してください。",
  "account-profile-field-error-6": "有効なURLを入力してください。",
  "account-profile-field-error-7":
    "有効なロゴデータをアップロードしてください。(PNG, JPEG, WebP)",
  "account-profile-field-error-8": "ロゴ画像のサイズは 1MB以下にしてください。",

  "account-profile-submit-1": "更新する",
  "account-profile-submit-2": "アップロード",

  "account-profile-toast-success": "正常に更新されました。",
  "account-profile-toast-error": "更新に失敗しました。",

  // MEMBER
  "account-member-tab": "メンバー",
  "account-member-title": "メンバー",
  "account-member-desc": "メンバーに関する管理、編集ができます。",

  "account-member-request-msg": "からエキスパートロールへの変更リクエストが来ています。",
  "account-member-request-button-accept": "許可",
  "account-member-request-button-reject": "却下",

  "account-member-account-num1": "アカウント：利用中",
  "account-member-account-num2": "",
  "account-member-support-num": "サポート:",
  "account-member-user-num": "ユーザー:",
  "account-member-count-admin": "管理者",
  "account-member-count-expert": "エキスパート",
  "account-member-count-user": "ユーザー",
  "account-member-count-support": "サポート",

  "account-member-toolbar": "メンバー追加",

  "account-member-table-col1": "名前",
  "account-member-table-col2": "メールアドレス",
  "account-member-table-col3": "ロール",
  "account-member-table-col4": "最終ログイン",
  "account-member-table-col5": "最終アップデート",

  "account-member-modal-add-title": "メンバー追加",
  "account-member-modal-add-discription":
    "完了したら更新をクリックしてください。",
  "account-member-modal-add-field-error-1": "このフィールドは入力が必須です。",
  "account-member-modal-add-field-error-2":
    "有効なメールアドレスを入力してください。",
  "account-member-modal-add-field-error-3":
    "有効なパスワードを入力してください。(大文字、小文字、数字、特殊文字を含み、8文字以上)。",
  "account-member-modal-add-filed-1": "名前",
  "account-member-modal-add-filed-2": "メールアドレス",
  "account-member-modal-add-filed-3": "パスワード",
  "account-member-modal-add-filed-4": "権限",
  "account-member-modal-add-filed-4-option-1": "エキスパート",
  "account-member-modal-add-filed-4-option-2": "管理者",
  "account-member-modal-add-filed-4-option-3": "パートナー",
  "account-member-modal-add-filed-4-option-4": "ユーザー",
  "account-member-modal-add-submit": "追加する",
  "account-member-modal-add-toast-success": "正常に更新されました。",
  "account-member-modal-add-toast-error": "更新に失敗しました。",
  "account-member-modal-edit-title": "メンバー編集",
  "account-member-modal-edit-discription":
    "完了したら更新をクリックしてください。",
  "account-member-modal-edit-field-error-1": "このフィールドは入力が必須です。",
  "account-member-modal-edit-filed-1": "名前",
  "account-member-modal-edit-filed-2": "権限",
  "account-member-modal-edit-filed-2-option-1": "エキスパート",
  "account-member-modal-edit-filed-2-option-2": "管理者",
  "account-member-modal-edit-filed-2-option-3": "パートナー",
  "account-member-modal-edit-filed-2-option-4": "ユーザー",
  "account-member-modal-edit-submit": "更新する",
  "account-member-modal-edit-toast-success": "正常に更新されました。",
  "account-member-modal-edit-toast-error": "更新に失敗しました。",
  "account-member-modal-self-edit-title": "メンバー編集",
  "account-member-modal-self-edit-discription":
    "完了したら更新をクリックしてください。",
  "account-member-modal-self-edit-field-error-1":
    "このフィールドは入力が必須です。",
  "account-member-modal-self-edit-field-error-2":
    "有効なパスワードを入力してください。(大文字、小文字、数字、特殊文字を含み、8文字以上)。",
  "account-member-modal-self-edit-filed-1": "名前",
  "account-member-modal-self-edit-filed-2": "古いパスワード",
  "account-member-modal-self-edit-filed-3": "新しいパスワード",
  "account-member-modal-self-edit-submit": "更新する",
  "account-member-modal-self-edit-toast-success": "正常に更新されました。",
  "account-member-modal-self-edit-toast-error": "更新に失敗しました。",
  "account-member-modal-delete-title": "メンバー削除",
  "account-member-modal-delete-discription":
    "完了したら削除をクリックしてください。",
  "account-member-modal-delete-field-error-1":
    "このフィールドは入力が必須です。",
  "account-member-modal-delete-field-error-2":
    "有効なメールアドレスを入力してください。",
  "account-member-modal-delete-filed-1": "名前",
  "account-member-modal-delete-filed-2": "メールアドレス",
  "account-member-modal-delete-submit": "削除する",
  "account-member-modal-delete-toast-success": "正常に更新されました。",
  "account-member-modal-delete-toast-error": "更新に失敗しました。",

  "account-member-dialog-reset-title": "MFA リセット",
  "account-member-dialog-reset-desc":
    "対象のメンバー情報に間違いがないことを確認してください。",

  "account-member-dialog-reset-field1": "名前",
  "account-member-dialog-reset-field1-validate": "この項目は必須項目です。",
  "account-member-dialog-reset-field2": "メールアドレス",
  "account-member-dialog-reset-field2-validate":
    "メールアドレスを入力してください",

  "account-member-dialog-reset-api-loading": "MFAリセットの処理中です。",
  "account-member-dialog-reset-api-success":
    "MFAリセットの処理が正常に完了しました。",
  "account-member-dialog-reset-api-error": "MFAリセットの処理が失敗しました。",

  "account-member-dialog-reset-button": "リセット",

  "account-member-modal-role-title": "xCausal™における役割",

  "account-member-modal-role-name-1": "エキスパート",
  "account-member-modal-role-name-2": "管理者",
  "account-member-modal-role-name-3": "パートナー",
  "account-member-modal-role-name-4": "ユーザー",

  "account-member-modal-role-item-1": "アシスタント - ユーザーモードの利用",
  "account-member-modal-role-item-2": "アシスタント - エキスパートモードの利用",
  "account-member-modal-role-item-3": "ダッシュボードの利用",
  "account-member-modal-role-item-4": "因果グラフの利用",
  "account-member-modal-role-item-5": "データ管理の利用",
  "account-member-modal-role-item-6": "RCAの利用",
  "account-member-modal-role-item-7": "CATEの利用",
  "account-member-modal-role-item-8": "アカウントの利用",
  "account-member-modal-role-item-9": "プロフィールの変更",
  "account-member-modal-role-item-10": "プロフィールロゴのアップロード",
  "account-member-modal-role-item-11": "メンバーの追加",
  "account-member-modal-role-item-12": "メンバーの削除",
  "account-member-modal-role-item-13": "契約情報の変更",
  "account-member-modal-role-item-14": "支払い情報の確認",
  
  // BILLING
  "account-billing-tab": "契約情報",
  "account-billing-section-1-title": "契約中プラン",
  "account-billing-section-1-discription":
    "組織に関する契約プランを確認することができます。",
  "account-billing-section-2-title": "プラン変更",
  "account-billing-section-2-discription":
    "組織に関する契約プランを変更することができます。",

  // INVOICE
  "account-invoice-tab": "支払い情報",
  "account-invoice-title": "領収書",
  "account-invoice-desc": "組織に関するお支払い情報の確認ができます。",

  "account-invoice-table-col1": "インボイスID",
  "account-invoice-table-col2": "日時",
  "account-invoice-table-col3": "価格",
  "account-invoice-table-col4": "ダウンロード",

  // SUPPORT
  "account-support-tab": "サポート",
  "account-support-title": "サポート",
};

export default account;
